<template>
  <Wrap class="sm">
    <FormFloat :title="$t('title')" @submit="save">
      <Notice v-if="message" :class="message.theme">
        {{ message.text }}
      </Notice>
      <Field
        v-if="!hasChanged"
        autocomplete="new-password"
        :label="$t('newPassword')"
        rules="password|passwordNumber|passwordNotAllNumeric"
        type="password"
        :value.sync="password" />
      <Btn v-show="!hasChanged" :isLoading="isLoading" type="submit">
        {{ $t('submit') }}
      </Btn>
      <Route v-show="hasChanged" class="Btn" to="Login">
        {{ $t('login') }}
      </Route>
    </FormFloat>
  </Wrap>
</template>

<script>
import FormFloat from '@forms/FormFloat'
import Message from '@mixins/Message'
import Meta from '@mixins/Meta'
import { actions } from '@utils'

export default {
  mixins: [
    Message,
    Meta(),
  ],
  components: { FormFloat },
  data() {
    return {
      password: '',
      isLoading: false,
      hasChanged: false,
    }
  },
  computed: {
    resetToken() {
      return this.$route.query.token
    },
  },
  methods: {
    async save() {
      this.$wrap(
        async () => {
          await this.PATCH_AUTHMANAGEMENT({
            id: null,
            password: this.password,
            resetToken: this.resetToken,
          })

          this.hasChanged = true
          this.success('Password changed!')
        },
        'isLoading',
      )
    },
    ...actions('LOGIN', 'PATCH_AUTHMANAGEMENT'),
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "meta": {
      "title": "Password reset",
      "description": "Forgot your password? You can reset it here."
    },
    "title": "Reset password",
    "newPassword": "New password",
    "submit": "Reset my password",
    "login": "Login"
  }
}
</i18n>
